import { IJebbitCampaignProps } from '@root/components/JebbitCampaign/models';
import Joi from 'joi';

const uriRequired = Joi.string().uri().required();

export const jebbitCampaignSchema = Joi.object<IJebbitCampaignProps>({
  title: Joi.string().required(),
  src: uriRequired,
  closeBtn: Joi.string().required(),
  isInModal: Joi.boolean().required(),
  isModalShowedOnlyOnce: Joi.boolean().required(),
  onCloseLocalStorageValue: Joi.string().required(),
  modalAppearingDelay: Joi.string().required(),
}).options({ stripUnknown: true });
